
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faculty/[slug]",
      function () {
        return require("private-next-pages/faculty/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faculty/[slug]"])
      });
    }
  